'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["threadId"];
import PropTypes from 'prop-types';
import { isSucceeded } from 'conversations-async-data/async-data/operators/statusComparators';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { useThreadDetails } from 'conversations-thread-view/thread-details-feature/public/hooks/useThreadDetails';
import { provideThreadView } from 'conversations-thread-view/thread-view/decorators/provideThreadView';
import { useThreadHistory } from 'conversations-thread-view/thread-histories/hooks/useThreadHistory';
import { BaseReplyEditor } from './BaseReplyEditor';
import { ReplyEditorLoadingState } from './ReplyEditorLoadingState';

/**
 * @description The application-facing interface for
 * common message reply editing + submission.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const _ReplyEditor = props => {
  const {
      threadId
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    asyncThreadDetails
  } = useThreadDetails({
    threadId
  });
  const threadDetails = getData(asyncThreadDetails) || isSucceeded(asyncThreadDetails);
  const {
    asyncThreadHistory
  } = useThreadHistory({
    threadId
  });
  const threadHistory = getData(asyncThreadHistory) || isSucceeded(asyncThreadHistory);
  if (!threadDetails || !threadHistory) {
    return /*#__PURE__*/_jsx(ReplyEditorLoadingState, {});
  }
  return /*#__PURE__*/_jsx(BaseReplyEditor, Object.assign({
    threadDetails: threadDetails,
    threadHistory: threadHistory
  }, rest));
};
_ReplyEditor.displayName = 'ReplyEditor';
_ReplyEditor.propTypes = {
  allowFullscreen: PropTypes.bool,
  associatedObjectId: PropTypes.number,
  associatedObjectTypeId: PropTypes.string,
  disableCalling: PropTypes.bool,
  callingSource: PropTypes.string,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
  editorFragment: PropTypes.string,
  onChannelChange: PropTypes.func,
  onDisabledChange: PropTypes.func,
  onEditorTabChange: PropTypes.func,
  renderExistingFileSelect: PropTypes.func,
  threadId: PropTypes.string.isRequired,
  inboxId: PropTypes.number.isRequired,
  isKnownVisitor: PropTypes.bool,
  renderSubmitButton: PropTypes.func
};
export const ReplyEditor = provideThreadView(_ReplyEditor);
ReplyEditor._WrappedComponent = _ReplyEditor;